import React from "react";
import "./SingleLineupSmallComponent.css";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import PlayerStatsInformation from "../../Content/PlayerCard/PlayerStatsInformation/PlayerStatsInformation";
import {
  getOptimizerDisplayNames,
  getStatsColumnMapping,
} from "../../../utils/columnsJsonInformation";
import { StarIcon } from "../../../utils/icons";
import { connect } from "react-redux";
import {
  API_CONSTANTS,
  DEFAULT_OPTIMIZER,
  RECOMMENDATION_OPTIMIZERS,
} from "../../../utils/constantInformation";
import { setSavedLineupCount } from "../../../redux/Lineup/LineupAction";
import { getID, serverTimestamp } from "../../../firebase";
import {
  addDataToLineupCollection,
  deleteDocument,
  getOneOfSameLineupsForSlateForUser,
} from "../../../firestoreQueries";

function SinglepneupSmallComponent(props) {
  const [favourite, setFavourite] = React.useState(false);
  const [lineupIdentifier, setLineupIdentifier] = React.useState(
    API_CONSTANTS.EMPTY_STRING
  );
  let singleLineup;
  if (props.myLineups === true) {
    singleLineup = props.singleLineup.data;
  } else {
    singleLineup = props.singleLineup;
  }

  React.useEffect(() => {
    setLineupIdentifier(singleLineup.lineup_identifier);
    console.log("Single Lineup", singleLineup);
    if (props.savedAllLineupsFlag === true) {
      setFavourite(true);
    }
  }, [props.savedAllLineupsFlag]);

  const getOptimizer = () => {
    console.log("optimizer", props.optimizer);
    console.log("lineup", singleLineup);
    if (RECOMMENDATION_OPTIMIZERS.includes(props.optimizer)) {
      return DEFAULT_OPTIMIZER;
    } else if (
      getOptimizerDisplayNames(props.league, props.remoteConfig).includes(
        props.optimizer
      )
    ) {
      return props.optimizer;
    } else if (props.myLineups === true) {
      if (props.league != null) {
        const column = getStatsColumnMapping(
          props.league,
          props.remoteConfig
        ).filter((el) => el.actual_name === props.optimizer);
        // alert(column);
        console.log("column", column);
        return column[0].display_name;
      }
    } else {
      return props.optimizer;
    }
  };

  const getFooterOptimizer = () => {
    if (RECOMMENDATION_OPTIMIZERS.includes(props.optimizer)) {
      return props.optimizer;
    } else if (
      getOptimizerDisplayNames(props.league, props.remoteConfig).includes(
        props.optimizer
      )
    ) {
      return props.optimizer;
    } else if (props.myLineups === true) {
      if (props.league != null) {
        const column = getStatsColumnMapping(
          props.league,
          props.remoteConfig
        ).filter((el) => el.actual_name === props.optimizer);
        // alert(column);
        console.log("column", column);
        return column[0].display_name;
      }
    } else {
      return props.optimizer;
    }
  };
  function formatDecimal(decimal) {
    // console.log("Decimal", decimal);
    let formattedDecimal = parseFloat(decimal).toFixed(1);
    let formattedIntegerDecimal =
      formattedDecimal < 10
        ? " " + formattedDecimal.toString()
        : formattedDecimal.toString();
    // console.log("Decimal", decimal, formattedDecimal, formattedIntegerDecimal);
    return formattedIntegerDecimal;
  }

  const handleSaveLineup = async () => {
    const userID = getID();
    const current_saved_lineup_count =
      props.lineupState.lineupReducer.saved_lineup_count;
    console.log("lineupCount", current_saved_lineup_count);
    // Update the saved_lineup_count here
    if (favourite) {
      // delete lineup
      const lineupToDelete = await getOneOfSameLineupsForSlateForUser(
        props.slate_id,
        lineupIdentifier,
        userID
      );
      lineupToDelete.forEach((document) => deleteDocument(document));
      props.update_saved_lineup_count(current_saved_lineup_count - 1);
    } else {
      // save lineup
      const toSend = {
        lineup: singleLineup,
        userID: userID,
        lineupIdentifier: lineupIdentifier,
        slateID: props.slate_id,
        createdAt: serverTimestamp(),
      };

      addDataToLineupCollection(toSend);

      props.update_saved_lineup_count(current_saved_lineup_count + 1);
    }
    setFavourite(!favourite);
  };

  const returnPlayerName = (playerData) => {
    const c_vc = playerData.c_vc;
    if (c_vc.length > 0) {
      return (
        <small>
          <b>( {playerData.c_vc} )</b>
        </small>
      );
    } else {
      return null;
    }
  };
  return (
    <div className="card_lc bg-secondary">
      <div className="card-header p-0 m-0 bg-transparent">
        {/* <div className="input-group mb-3"> */}
        <div className="d-flex">
          <div className="input-group-prepend border-dark">
            <span
              class="input-group-text bg-dark border-top-0 border-bottom-0 border-left-0"
              onClick={handleSaveLineup}
            >
              {" "}
              <>
                {props.myLineups ? (
                  <p className="text-white align-items-center align-self-center">
                    {parseInt(props.index) + 1}
                  </p>
                ) : favourite ? (
                  <StarIcon className="text-yellow align-items-center align-self-center" />
                ) : (
                  <StarBorderIcon className="text-white align-items-center align-self-center" />
                )}
              </>
            </span>
          </div>
          <PlayerStatsInformation
            player_stats={singleLineup["aggregated_stats"]} // here player_stats are aggregated team stats
            key={1}
            background_dark={true}
            show_bottom_border={false}
            lineup_card={true}
            optimizer={props.optimizer}
          />

          <div class="input-group-append ml-auto border-dark">
            <span
              class="input-group-text bg-dark border-top-0 border-bottom-0 border-right-0"
              id="basic-addon2"
            >
              <div className="d-flex flex-column bg-dark ">
                {/* <div className="stat-box-small "> */}
                <small>
                  <center>
                    <p className="text-center text-white mb-1">
                      {getOptimizer()}
                    </p>
                  </center>
                </small>
                {/* </div> */}
                {props.league &&
                  getStatsColumnMapping(props.league, props.remoteConfig)
                    .filter((column) => column.display_name === getOptimizer())
                    .map((information, index) => (
                      // <div className="stat-box-small">
                      <small>
                        <center>
                          <p className="text-center m-0 text-white font-weight-bold">
                            {Number(
                              singleLineup["aggregated_stats"][
                                information.actual_name
                              ]
                            )
                              .toFixed(1)
                              .replace(/\.0$/, "")}
                          </p>
                        </center>
                      </small>
                      // </div>
                    ))}
              </div>
            </span>
          </div>
        </div>

        {/* <h4 className="align-items-center align-self-center">Header Here</h4> */}
        {/* <select className="custom-select" id="inputGroupSelect01">
            <option selected>Choose...</option>
            <option value="1">One</option>
            <option value="2">Two</option>
            <option value="3">Three</option>
          </select> */}
        {/* <div className="input-group-append">
            <p className="align-items-center align-self-center">29FP</p>
          </div> */}
        {/* </div> */}
      </div>
      <div className="d-flex align-self-center justify-content-center bg-dark pl-2 pr-2 pt-3 pb-3">
        <div className="row w-100 row-cols-1 row-cols-md-2 row-cols-lg-2 row-cols-sm-1 row-cols-xs-1">
          {/* Card Content Begin */}
          {singleLineup["players"].map((playerData) => (
            <div className="  w-100 d-flex justify-content-between pl-2 pr-2 border border-secondary rounded">
              <p className="text-nowrap p-0 m-0 align-items-center align-self-center">
                <small className="d-flex p-0 m-0 text-white ">
                  <small className="text-primary font-weight-bold align-items-center align-self-center p-0 m-0">
                    {playerData.position.slice(0, 2)}
                  </small>
                  &emsp;
                  <p className="m-0 p-0">
                    {playerData.player_name} {returnPlayerName(playerData)}
                  </p>
                </small>
              </p>
              <p className="text-nowrap m-0 p-0 text-white align-items-center align-self-center">
                <small className="d-flex justify-content-between ">
                  {/* <small className="m-0 p-0"> */}
                  {/* {returnPlayerName(playerData)}{" "} */}
                  {/* </small> */}
                  <small className="m-0 p-0">
                    CR: {formatDecimal(playerData["salary"])}
                  </small>
                  <small>
                    {/* <p>{playerData["salary"]}</p> */}
                    &emsp;&ensp;
                    {playerData["fppg"].toFixed(1) == -999 // TODO: check this later for null or numeric null
                      ? "--"
                      : playerData["fppg"].toFixed(1)}
                  </small>
                </small>
              </p>
            </div>
          ))}

          {/* Card Content End */}
        </div>
      </div>
      <div className="card-footer bg-transparent d-flex text-white justify-content-between pb-0 pl-2 pr-2">
        <p>
          <small>DailyFantasy</small>
        </p>
        <p>
          <small>CR: {singleLineup["salary_costs"]}</small>
        </p>
        <p>
          <small>{getFooterOptimizer()}</small>
        </p>
      </div>
    </div>

    //<p >
    // <div className="d-flex justify-content-between">
    //   <p>
    //     <small>
    //       <b>WK</b>
    //     </small>
    //     Lorem
    //   </p>
    //   <div className="d-flex">
    //     <p>&#8377; 90</p>
    //     <p>45.7</p>
    //   </div>
    // </div>
    // </p>
    //   <div className="d-flex justify-content-between">
    //     {/* Footer */}
    //     <p>DailyFantasy</p>
    //     <p>&#8377; 90</p>
    //     <p>Projected Points</p>
    //   </div>
    // </div>
  );
}
const mapStateToProps = (state) => {
  return {
    slate_id: state.gameInformationReducer.slate_id,
    league: state.gameInformationReducer.sports,
    lineupState: state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    update_saved_lineup_count: (value) => dispatch(setSavedLineupCount(value)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SinglepneupSmallComponent);
